var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { IconBuilding } from "../../../generic/common/icon-building/IconBuilding";
import { IdIconBuildingContext } from "../../../generic/common/icon-building/IdIconBuildingContext";
import { ImageBoxContainer } from "../../../generic/common/ImageBoxContainer";
import { BuildingItemLevel } from "./BuildingItemLevel";
export var BuildingItemContainer = function (_a) {
    var buildingName = _a.buildingName, className = _a.className, stage = _a.stage;
    var level = stage.visualLevel || stage.level || 1;
    return (React.createElement(ImageBoxContainer, null,
        React.createElement("div", { className: "building-upgrade__image-container" },
            React.createElement("div", { className: "building-upgrade__image" },
                React.createElement(IconBuilding, { level: level, buildingName: buildingName, context: IdIconBuildingContext.UpgradeBuildingItem })),
            React.createElement(BuildingItemLevel, __assign({}, stage)))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/upgrade/BuildingItemContainer.tsx
// module id = 441
// module chunks = 3